export const storeDataInLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getDataFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  if (data) return JSON.parse(data);
  return null;
};

export const removeDataFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const resetProperty = (keyName, property) => {
  const clinicData = getDataFromLocalStorage(keyName);
  if (clinicData) {
    clinicData[property] = "";
  }
  storeDataInLocalStorage(keyName, clinicData);
};
